import React, { memo, useCallback } from 'react';
import { Check, AlertCircle, RefreshCw, X } from 'lucide-react';
import './SubitemStatusIndicator.css';

const SubitemStatusIndicator = memo(({ 
  status, 
  onStatusChange, 
  disabled = false,
  isUpdating = false 
}) => {
  
  // Status options with their properties
  const statusOptions = [
    { value: 'Done', label: 'Done', icon: Check, className: 'status-done' },
    { value: 'Working on it', label: 'Working on it', icon: RefreshCw, className: 'status-working' },
    { value: 'Stuck', label: 'Stuck', icon: AlertCircle, className: 'status-stuck' },
    { value: 'N/A', label: 'N/A', icon: X, className: 'status-na' }
  ];
  
  // Handle status selection with deselect capability
  const handleStatusClick = useCallback((newStatus) => {
    console.log('🎯 Status clicked:', { newStatus, currentStatus: status, disabled, isUpdating });
    
    if (!disabled && !isUpdating) {
      // If clicking the same status, deselect it (set to empty)
      if (newStatus === status) {
        console.log('🔄 Deselecting status');
        onStatusChange('');
      } else {
        console.log('✅ Changing status to:', newStatus);
        onStatusChange(newStatus);
      }
    } else {
      console.log('⚠️ Click ignored - disabled:', disabled, 'isUpdating:', isUpdating);
    }
  }, [status, onStatusChange, disabled, isUpdating]);
  
  return (
    <div className="status-indicators-horizontal">
      {statusOptions.map(option => {
        const Icon = option.icon;
        const isActive = status === option.value;

        return (
          <div key={option.value} className="status-button-wrapper">
            <button
              type="button"
              className={`status-indicator-horizontal ${option.className} ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''} ${isUpdating ? 'updating' : ''}`}
              onClick={() => handleStatusClick(option.value)}
              disabled={disabled || isUpdating}
            >
              <Icon
                className="status-icon"
                size={14}
              />
            </button>
            <div className="status-tooltip">{option.label}</div>
          </div>
        );
      })}
    </div>
  );
});

SubitemStatusIndicator.displayName = 'SubitemStatusIndicator';

export default SubitemStatusIndicator;